var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-pay-generic-viewer',{attrs:{"title":"My Merchant","bean":_vm.merchant,"beanProperties":_vm.viewableMerchantProperties,"beanLabels":_vm.merchantLabels,"statusClasses":_vm.merchantStatusClasses,"formatters":{ createdDate: _vm.formatDate }}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5abe0b56","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/merchant/MPayMerchantLimitedView.vue
// module id = null
// module chunks = 